<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <p-card>
    <div class="p-fluid">
      <div class="field">
        <label class="font-medium required-field">Название</label>
        <crm-input-text
          [(value)]="camera.name"
          [isError]="$any(errors?.name)"></crm-input-text>
        <small
          *ngIf="errors?.name"
          class="p-error">
          {{ errors.name | join }}
        </small>
      </div>

      <div class="field">
        <label class="font-medium required-field block mb-2">Направление</label>
        <div class="block">
          <p-selectButton
            [options]="directionOptions"
            [(ngModel)]="camera.direction"
            optionLabel="label"
            optionValue="value"></p-selectButton>
        </div>
        <small
          *ngIf="errors?.direction"
          class="p-error">
          {{ errors.direction | join }}
        </small>
      </div>

      <div class="field-checkbox">
        <p-checkbox
          [(ngModel)]="camera.secured"
          [binary]="true"
          inputId="distributeCosts"></p-checkbox>
        <label [for]="'distributeCosts'">Использовать защищенное соединение</label>
      </div>

      <div class="field-checkbox">
        <p-checkbox
          [(ngModel)]="camera.doNotOpenBarrier"
          [binary]="true"
          inputId="doNotOpenBarrier"></p-checkbox>
        <label [for]="'doNotOpenBarrier'">Не открывать шлагбаум</label>
      </div>

      <div class="field">
        <label class="font-medium required-field">Хост</label>
        <crm-input-text
          [(value)]="camera.host"
          [isError]="$any(errors?.host)"></crm-input-text>
        <small
          *ngIf="errors?.host"
          class="p-error">
          {{ errors.host | join }}
        </small>
      </div>

      <div class="field">
        <label class="font-medium required-field">Порт</label>
        <p-inputNumber
          [(ngModel)]="camera.port"
          [min]="1"
          [ngClass]="{ 'ng-invalid ng-dirty': errors?.port }"
          class="w-full"
          styleClass="w-full"></p-inputNumber>
      </div>

      <div class="field">
        <label class="font-medium required-field">Логин</label>
        <crm-input-text
          [(value)]="camera.login"
          [isError]="$any(errors?.login)"></crm-input-text>
        <small
          *ngIf="errors?.login"
          class="p-error">
          {{ errors.login | join }}
        </small>
      </div>

      <div class="field">
        <label class="font-medium required-field">Пароль</label>
        <crm-input-text
          [(value)]="camera.password"
          [isError]="$any(errors?.password)"></crm-input-text>
        <small
          *ngIf="errors?.password"
          class="p-error">
          {{ errors.password | join }}
        </small>
      </div>

      <div class="field">
        <label class="font-medium">Как открывать шлагбаум</label>
        <crm-barrier-open-mode-single-select
          [(selectedMode)]="camera.barrierOpenMode"
          [showClear]="true"
          appendTo="body"
          placeholder="Выберите режим"></crm-barrier-open-mode-single-select>
      </div>

      <div
        *ngIf="camera.barrierOpenMode === BarrierOpenModeEnum.CONVERTER"
        class="field">
        <label class="font-medium">Оборудование</label>
        <crm-converter-single-select
          [(selectedConverter)]="camera.converter"
          [showClear]="true"
          appendTo="body"
          placeholder="Выберите оборудование"></crm-converter-single-select>
      </div>

      <div
        *ngIf="camera.barrierOpenMode === BarrierOpenModeEnum.NET_PING_DEVICE"
        class="field">
        <label class="font-medium">Устройство &laquo;NetPing&raquo;</label>
        <crm-net-ping-device-single-select
          [(selectedNetPingDevice)]="camera.netPingDevice"
          [showClear]="true"
          appendTo="body"
          placeholder="Выберите устройство &laquo;NetPing&raquo;"></crm-net-ping-device-single-select>
      </div>
    </div>
  </p-card>

  <div class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <crm-button
        [label]="saveButtonLabel"
        styleClass="p-button-success"
        (onClick)="saveCamera()"></crm-button>

      <ng-container *ngIf="(form$ | async)?.isShowDelete">
        <crm-button
          *ngIf="!camera['deleted']"
          label="Удалить"
          styleClass="p-button-danger p-button-text"
          (onClick)="deleteCamera()"></crm-button>
      </ng-container>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
